import { useEffect, useState } from "react";
import { useUserPreferences } from "../contexts/UserPreferencesContext";

export const useDesign = () => {
	const { design } = useUserPreferences();
	const [resolvedDesign, setResolvedDesign] = useState(design);

	useEffect(() => {
		setResolvedDesign(design);

		// Optional: apply design as a class to root for global styling
		const targets = [document.documentElement, document.body];
		targets.forEach(el => {
			el.classList.remove("ios18", "ios26");
			el.classList.add(design);
		});
	}, [design]);

	return { design: resolvedDesign };
};
